/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Referral } from './Referral';
import {
    ReferralFromJSON,
    ReferralFromJSONTyped,
    ReferralToJSON,
    ReferralToJSONTyped,
} from './Referral';

/**
 * 
 * @export
 * @interface GenerateAllReferralsResponse
 */
export interface GenerateAllReferralsResponse {
    /**
     * 
     * @type {Array<Referral>}
     * @memberof GenerateAllReferralsResponse
     */
    referrals: Array<Referral>;
}

/**
 * Check if a given object implements the GenerateAllReferralsResponse interface.
 */
export function instanceOfGenerateAllReferralsResponse(value: object): value is GenerateAllReferralsResponse {
    if (!('referrals' in value) || value['referrals'] === undefined) return false;
    return true;
}

export function GenerateAllReferralsResponseFromJSON(json: any): GenerateAllReferralsResponse {
    return GenerateAllReferralsResponseFromJSONTyped(json, false);
}

export function GenerateAllReferralsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateAllReferralsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referrals': ((json['referrals'] as Array<any>).map(ReferralFromJSON)),
    };
}

export function GenerateAllReferralsResponseToJSON(json: any): GenerateAllReferralsResponse {
    return GenerateAllReferralsResponseToJSONTyped(json, false);
}

export function GenerateAllReferralsResponseToJSONTyped(value?: GenerateAllReferralsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referrals': ((value['referrals'] as Array<any>).map(ReferralToJSON)),
    };
}

